/** @module csi/widget/_svg/ImpossiblePlaceholderPopup*/
define([
	"dojo/_base/declare",
	"dijit/form/Button",
	"dijit/_TemplatedMixin",
	"dijit/_WidgetBase",
	"dijit/_WidgetsInTemplateMixin",
	"dojo/text!csi/widget/_svg/impossiblePlaceholder.html",

	"csi/widget/CheckBox",
	"csi/widget/FilteringSelect",
	"csi/widget/ValidationTextBox"
], function(declare,Button,_TemplatedMixin,_WidgetBase,_WidgetsInTemplateMixin,template) {

	return declare([_WidgetBase,_TemplatedMixin,_WidgetsInTemplateMixin], {
		// Canvas editor
		editor: null,
		templateString: template,
		
		// functions for clicking the buttons
		removeClick: function() {},
		ignoreClick: function() {},
		
		_onRemoveClick: function() {
			this.removeClick();
		},
		
		_onIgnoreClick: function() {
			this.ignoreClick();
		}
	});
});